import type { OidcConfiguration } from "@axa-fr/react-oidc";
import { runtimeConfig } from "@/runtime-config";
import { registerTickbirdServiceWorker } from "@/service-worker";

const parseBoolean = (value: string | undefined) => value?.toLowerCase() === "true";

const authority = runtimeConfig.oidcAuthority?.trim() || import.meta.env.VITE_OIDC_AUTHORITY?.trim() || "";
const clientId = runtimeConfig.oidcClientId?.trim() || import.meta.env.VITE_OIDC_CLIENT_ID?.trim() || "";
const useServiceWorker = parseBoolean(runtimeConfig.oidcUseServiceWorker || import.meta.env.VITE_OIDC_USE_SERVICE_WORKER);

export const oidcIsConfigured = authority.length > 0 && clientId.length > 0;
export const oidcUsesDpop = parseBoolean(runtimeConfig.oidcUseDpop || import.meta.env.VITE_OIDC_USE_DPOP);

export const oidcConfiguration: OidcConfiguration = {
  authority,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/authentication/callback`,
  silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`,
  scope: runtimeConfig.oidcScope?.trim() || import.meta.env.VITE_OIDC_SCOPE?.trim() || "openid profile email offline_access tickbird.api",
  extras: {
    resource: runtimeConfig.oidcAudience?.trim() || import.meta.env.VITE_OIDC_AUDIENCE?.trim() || "urn:tickbird:api:admin",
  },
  par: "auto",
  storage: localStorage,
  service_worker_relative_url: useServiceWorker ? "/TickbirdServiceWorker.js" : undefined,
  service_worker_register: useServiceWorker ? registerTickbirdServiceWorker : undefined,
  service_worker_only: false,
  demonstrating_proof_of_possession: oidcUsesDpop,
};
